//#region src/internalTypes.ts
let EventType = /* @__PURE__ */ function(EventType$1) {
	EventType$1["ACTION_START"] = "action:start";
	EventType$1["ACTION_END"] = "action:end";
	EventType$1["OPERATOR_START"] = "operator:start";
	EventType$1["OPERATOR_END"] = "operator:end";
	EventType$1["OPERATOR_ASYNC"] = "operator:async";
	EventType$1["MUTATIONS"] = "mutations";
	EventType$1["EFFECT"] = "effect";
	EventType$1["DERIVED"] = "derived";
	EventType$1["DERIVED_DIRTY"] = "derived:dirty";
	EventType$1["COMPONENT_ADD"] = "component:add";
	EventType$1["COMPONENT_UPDATE"] = "component:update";
	EventType$1["COMPONENT_REMOVE"] = "component:remove";
	EventType$1["GETTER"] = "getter";
	return EventType$1;
}({});

//#endregion
export { EventType };
//# sourceMappingURL=internalTypes.js.map